import * as actionTypes from './actionTypes';

const initialState = {
  home: {},
  error: { homeError: false, message: '' },
  isFetching: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_HOME_REQUEST:
      return { ...state, isFetching: true };
    case actionTypes.FETCH_HOME_SUCCESS:
      return { ...state, home: action.home, isFetching: false };
    case actionTypes.FETCH_HOME_FAILURE:
      return { ...state, error: { homeError: true, messages: action.messages }, isFetching: false };
    default:
      return state;
  }
};

export { reducer as default };
